import { Icon, IconProps } from '@chakra-ui/react'

export default function ChatMessageIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#343A40'}
      {...props}
    >
      <path
        d="M9.33325 11.8332H22.6666"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33325 18.5002H22.6666"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7811 25.8333L15.0572 28.1095C15.5779 28.6301 16.4221 28.6301 16.9428 28.1095L19.2189 25.8333H24C26.2091 25.8333 28 24.0425 28 21.8333V8.5C28 6.29086 26.2091 4.5 24 4.5H8C5.79086 4.5 4 6.29086 4 8.5V21.8333C4 24.0425 5.79086 25.8333 8 25.8333H12.7811Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
